import { ContentButton } from '../content/button';
import { InternHeadline } from '../intern/headline';
import { InternText } from '../intern/text';

/**
 * Model definition for ContactForm
 */
export interface FormsContactForm {
  __component: 'forms.contact-form';
  id: string;
  formHeadline?: InternHeadline;
  formText?: string;
  formSubject: InternText[];
  privacyText?: string;
  infoText?: string;
  ctaButton?: ContentButton;
  confirmationHeadline?: InternHeadline;
  confirmationText?: string;
  showBankCodeAssignment?: boolean;
  showWayToContact?: boolean;
  showPersonalInfo?: boolean;
  showMessage?: boolean;
}

export function isFormsContactForm(obj: { __component?: string }): obj is FormsContactForm {
  return obj.__component === 'forms.contact-form';
}
